import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useContext, useEffect, useState } from 'react';

import { PaymentPeriod, PaymentPlan } from '@features/payments';
import EnterpriseInfoModal from '@features/payments/components/EnterpriseInfoModal/EnterpriseInfoModal';
import PaymentPlanUpdateConfirmationModal from '@features/payments/components/PaymentPlanUpdateConfirmationModal/PaymentPlanUpdateConfirmationModal';
import { Plan } from '@features/payments/components/PricingOptions/constants';
import PricingOptions from '@features/payments/components/PricingOptions/PricingOptions';
import { useGetPaymentPlans } from '@features/payments/hooks/useGetPaymentPlans';
import EnterpricePlanUpdateConfirmationModal from './../EnterpricePlanUpdateConfirmationModal/EnterpricePlanUpdateConfirmationModal';
import CloseIcon from '@mui/icons-material/Close';
import { EditIcon } from '../../../../vectors/index';
import { useGetCurrentPlan } from '@features/payments/hooks/useGetCurrentPlan';
import { authContext } from '@staffedupusa/shared-components';
import UpdateCardInfo from '@features/enterprise/components/UpdateCardInfo';

type UpdatePaymentPlanModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};
// const currentPlanData = {
//   status: 200,
//   message: 'Plan returned',
//   object: {
//     plan_int: 2,
//     name: 'Annually',
//     id: 'price_1NAhRaLEJ4nWngvRJn58eK8L',
//     sub_user_plan: 'plan_FjvGq5lDXHHOFY',
//   },
// };

const UpdatePaymentPlanModal: FC<UpdatePaymentPlanModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const [isEnterpriseInfoModalOpen, setIsEnterpriseInfoModalOpen] =
    useState(false);
  const {
    authData: { user },
  } = useContext(authContext);

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  const [paymentPeriod, setPaymentPeriod] = useState<PaymentPeriod>('Annually');
  const [selectedPlanId, setSelectedPlanId] = useState<string | null>(null);

  const { paymentPlansData } = useGetPaymentPlans();
  const { currentPlanData } = useGetCurrentPlan();

  const handleSelectPlan = (plan: Plan) => {
    setSelectedPlan(plan);

    if (plan === 'StaffedUp Enterprise') {
      setIsEnterpriseInfoModalOpen(true);
    } else {
      const paymentPlan = (paymentPlansData?.object as PaymentPlan[])?.find(
        (paymentPlant) =>
          plan === 'StaffedUp Service'
            ? paymentPlant.name === 'StaffedUp Service'
            : paymentPlant.name === 'StaffedUp Service+',
      );

      if (paymentPlan) {
        for (const planId in paymentPlan.intervals) {
          // TODO: fix ts warning
          // @ts-ignore
          const updatedPlan = paymentPlan.intervals[planId];

          if (updatedPlan.name === paymentPeriod) {
            setSelectedPlanId(updatedPlan.id);
          }
        }
      }
      if (user?.enterprise?.plan) {
        setIsConfirmationModalOpen(true);
      }
    }
  };

  useEffect(() => {
    if (currentPlanData?.object) {
      switch (currentPlanData?.object.plan_int) {
        case 1:
          setSelectedPlan('StaffedUp Service');
          break;
        case 2:
          setSelectedPlan('Service + Onboarding');
          break;
        default:
          break;
      }

      setPaymentPeriod(currentPlanData.object.name as PaymentPeriod);
    }
  }, [currentPlanData]);

  return (
    <>
      <Dialog open={isOpen} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <IconButton
            sx={{ position: 'absolute', top: 5, right: 5 }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <br />
          <EditIcon />
          <br />
          <Typography variant="h4">Select Plan</Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3} alignItems="center">
            <PricingOptions
              handleSelectPlan={handleSelectPlan}
              selectedPlan={selectedPlan}
              setPaymentPeriod={setPaymentPeriod}
              initialPaymentPeriod={paymentPeriod}
            />
          </Stack>
        </DialogContent>
      </Dialog>
      <EnterpricePlanUpdateConfirmationModal
        isOpen={isConfirmationModalOpen}
        handleClose={() => setIsConfirmationModalOpen(false)}
        planId={selectedPlanId as string}
      />
      <EnterpriseInfoModal
        isOpen={isEnterpriseInfoModalOpen}
        handleClose={() => setIsEnterpriseInfoModalOpen(false)}
      />
      {!user?.enterprise?.plan && selectedPlanId && (
        <UpdateCardInfo
          selectedPlanId={selectedPlanId}
          handleClose={() => setSelectedPlanId(null)}
        />
      )}
    </>
  );
};

export default UpdatePaymentPlanModal;
